import {createAction} from '@reduxjs/toolkit';

import type {User} from '../types/user';

export const receivedCurrentUser = createAction<User>('users/actions/receivedCurrentUser');
